import useDropdownData from './use-dropdown-data';

export default useDropdownData;
